import React, { useEffect, useMemo } from 'react'
import PropTypes, { string, shape, object, func, bool } from 'prop-types'
import { Form, Select } from 'antd'
import { getCityField } from '~/states/modules/cityField'
import { useDispatch, useSelector } from 'react-redux'
import InfoField from '~/components/infoField'
import { filterText } from '~/services/filter'
import { useFocusCallback } from 'utils/fieldHooks'

const CityField = ({
	pageFieldsData,
	className,
	inputValue,
	state,
	form,
	onChange,
	onFocus,
	disabled,
	visible,
}) => {
	const { label, variable, type, id, info, list, optional, listName } =
		pageFieldsData
	const isObj = typeof variable === 'object'
	const varname = isObj ? variable.name : variable
	const name = id !== undefined ? `${varname}_${id}` : varname

	const dispatch = useDispatch()

	const { data } = useSelector(({ cityField }) => cityField)

	useEffect(() => {
		if (!data) dispatch(getCityField())
	}, [dispatch, data])

	const cityOptions = useMemo(() => {
		if (data) {
			if (state) {
				return data
					.filter((item) => item.state === state)
					.map((item) => item.city)
			} else {
				return data.map((item) => item.city)
			}
		}

		return []
	}, [data, state])

	useEffect(() => {
		if (form) {
			let value = ''
			if (listName !== list) {
				value = form.getFieldsValue()[listName][list][name] ?? ''
			} else {
				value = form.getFieldsValue()[list][name] ?? ''
			}

			if (data && value) {
				const city = data.find((item) => value === item.city)
				if (state && city?.state !== state) {
					form.setFieldsValue({ [list]: { [name]: '' } })
				}
			}
		}
	}, [listName, state, data, form, list, name])

	const focusCallback = useFocusCallback(onFocus, pageFieldsData)

	return (
		<Form.Item
			key={name}
			name={list !== undefined ? [list, name] : name}
			label={<InfoField label={label} info={info} />}
			hasFeedback
			className={className}
			rules={
				visible && [
					{ required: !optional, message: 'Este campo é obrigatório.' },
				]
			}
			type={type}
			colon={false}
			initialValue={!inputValue ? '' : inputValue}>
			<Select
				allowClear={optional}
				showSearch={true}
				disabled={disabled}
				filterOption={filterText}
				onChange={onChange}
				onFocus={focusCallback}>
				{cityOptions.map((option, index) => (
					<Select.Option key={index} value={option} label={option}>
						{option}
					</Select.Option>
				))}
			</Select>
		</Form.Item>
	)
}

CityField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: object.isRequired,
		type: string.isRequired,
		info: string,
	}).isRequired,
	className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	onChange: func,
	onFocus: func,
	form: object,
	inputValue: string,
	disabled: bool,
	visible: bool,
	state: string,
	addressData: object,
}

CityField.defaultProps = {
	className: {},
	visible: true,
}

export default CityField
